import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Platform } from 'react-native';
import Backend from 'i18next-http-backend';
import i18nResources from './i18nResources';
import { useCallback } from 'react';

export const i18nNS = {
  common: 'common',
  login: 'login',
  forgotPassword: 'forgotPassword',
  searchWidget: 'searchWidget',
  settings: 'settings',
  me: 'me',
  checkout: 'checkout',
  contacts: 'contacts',
  resultCards: 'resultCards',
  tripSummary: 'tripSummary',
  air: 'air',
  car: 'car',
  hotel: 'hotel',
  rail: 'rail',
  myTrips: 'myTrips',
  terms: 'terms',
  privacy: 'privacy',
  calendar: 'calendar',
  tripHub: 'tripHub',
  tripExpense: 'tripExpense',
};

const translationLoader = {
  type: 'backend',
  init: () => {},
  read: function (language, namespace, callback) {
    let resource,
      error = null;
    try {
      resource = i18nResources[language][namespace]();
    } catch (_error) {
      error = _error;
    }
    callback(error, resource);
  },
};

i18n
  .use(Platform.OS === 'web' ? Backend : translationLoader)
  .use(initReactI18next)
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    ns: ['common', 'settings', 'myTrips'],
    defaultNS: ['common', 'login'],
    lng: 'en',
    fallbackLng: 'en',
    debug: __DEV__,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend:
      Platform.OS === 'web'
        ? {
            loadPath: '/assets/i18n/{{ns}}/{{lng}}.json',
          }
        : undefined,
  });

export default i18n;

export const useComponentTKey = (componentName) => {
  const tKey = useCallback((key) => `${componentName}.${key}`, [componentName]);
  return { tKey };
};

export const lngMap = {
  en: 'English',
  es: 'Español',
  de: 'German',
  fr: 'Français',
  it: 'Italian',
  pt: 'Portugese',
};
